
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/request-reset",
      function () {
        return require("private-next-pages/request-reset.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/request-reset"])
      });
    }
  